import { createContext } from "react";
import useSWR from "swr";
import useAuth from "../hooks/useAuth";

export const GeneralContext = createContext<{
  generals: any;
}>({
  generals: {},
});

const GeneralProvider = ({ children, generals }: any) => {
  const { hasPermission } = useAuth();
  const isAdmin = hasPermission([{ method: "GET", route: "/general/admin" }]);
  const { data } = useSWR(isAdmin ? "/general/admin" : `/general`);
  // if (!data) return <LoadingC />;
  return (
    <GeneralContext.Provider value={{ generals: data }}>
      {children}
    </GeneralContext.Provider>
  );
};

export default GeneralProvider;
